import { AccountType } from '@collections/companies/enums';
import { ICategory } from '@collections/categories/interfaces/category.interface';
import { ICompany, ICompanyBase } from '@collections/companies/interfaces/company.interface';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyBySlugGQL } from '@shared/services/company/companyBySlug.gql.service';
import { IPortalEvent } from '@collections/portal-events/interfaces/portal-events.interface';
import { INews } from '@collections/news/interfaces/news.interface';
import { IUser } from '@collections/users/interfaces/user.interface';
import { UserInfo } from '@shared/services/users/types/user-info';
import { HOST_URL } from 'app/shared/tokens/host-url';
import { LanguagesService } from '../languages/languages.service';

@Injectable({
  providedIn: 'root'
})
export class RoutesService {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    @Inject(HOST_URL) private hostUrl: string,
    private languagesService: LanguagesService,
){ }

  getCompanyUrl(company: Partial<ICompany>, path?: string, absolute=false): string {
    path = path ?? company.primaryPath;
    let url =  this.formatCompanyUrl(path, company.slug, company.accountType);
    if (absolute) {
      url = this.getAbsoluteUrl(url)
    }
    return url;
  }

  getCompanyAltLangUrl(company: ICompany, lang: string): string {
    const pathLocale = company.primaryPathLocales
    .find(p => p.lang === lang);
    if (!pathLocale) {
      throw new Error(`no company path found for ${lang} language`);
    }
    return  this.formatCompanyUrl(pathLocale.path, company.slug, company.accountType);
  }

  getCompanyEditUrl(company: ICompanyBase, lang: string = this.locale): string {
    const editUrl = `${this.getCompanyUrl(company)}/edit/info/${lang}/${company._id}`;
    return editUrl;
  }

  // getCompanyUrlBySlug(slug: string, lang: string): Observable<string> {
  //   return this.companyBySlugGQL.fetch({
  //       slug: slug,
  //       lang: lang
  //   }, {
  //     fetchPolicy: 'cache-first'
  //   })
  //   .pipe(
  //     map(({data: {companyBySlug: company}}) => this.formatCompanyUrl(company.primaryPath, company.slug, company.accountType))
  //   );
  // }

  private formatCompanyUrl(primaryPath: string, slug: string, accountType: AccountType): string {
    if (!primaryPath || !slug || ! accountType) {
      throw new Error(`Got insuficient parameters for company url: ${slug}`);

    }
    const page = accountType === AccountType.customer ? 'stand' : 'stand-free';
    return  `/hall${primaryPath}/${page}/${slug}`;
  }

  getProductUrl(company: Partial<ICompany>, productSlug: string, path?: string, absolute=false): string {
    path = path ?? company.primaryPath;
    let url = this.formatCompanyUrl(path, company.slug, company.accountType);
    url = `${url}/products/${productSlug}`;
    if (absolute) {
      url = this.getAbsoluteUrl(url);
    }
    return url;
  }

  getWikiUrl(wikiSlug: string, absolute=false): string {
    let url = `/metal-working-basics/${wikiSlug}`;
    if (absolute) {
      url = this.getAbsoluteUrl(url);
    }
    return url;
  }

  // getProductUrlBySlug(productSlug: string, company: ICompany, lang: string): Observable<string> {
  //   const companyUrl = this.getCompanyUrl(company, lang);
  //   return `${url}/products/${productSlug}`;
  // }


  // getNewsUrlBySlug(newsSlug: string, companySlug: string, lang: string): Observable<string> {
  //   if (companySlug) {
  //     return this.getCompanyUrlBySlug(companySlug, lang)
  //     .pipe(
  //       map( url => `${url}/news/${newsSlug}`)
  //     );
  //   } else {
  //     return of(`/news/${newsSlug}`);
  //   }
  // }

  getCategoryUrl(slug: string): string {
    return `/hall${slug}`;
  }

  getCategoryUrlBySlug(categorySlug: string): Observable<string> {
    return of(`/hall/${categorySlug}`);
  }

  getEventUrl(event: IPortalEvent): string {
      return  `/events/${event.slug}`;
  }

  getNewsUrl(slug: string, company?: ICompanyBase, absolute=false): string {
    let url;
    if (company) {
      const companyUrl = this.getCompanyUrl(company);
      url =`${companyUrl}/news/${slug}`;
    } else {
      url = `/news/${slug}`;
    }

    if (absolute) {
      url = this.getAbsoluteUrl(url);
    }
    return url;
  }

  getUserUrl(user: UserInfo | IUser, absolute=false): string {
    let url =  `/account/${user.slug}`;
    if (absolute) {
      url = this.getAbsoluteUrl(url);
    }
    return url;
  }

  public getAbsoluteUrl(url: string, lang: string = ''): string {
    // Se in Dev Mode andrebbe tolta la lingua
    const absolute = `${this.hostUrl}/${lang ? lang : this.languagesService.getCurrentLangCode()}${url}`;
    const urlObj = new URL(absolute);
    const allowedSearchParams = ['after'];
    for (const k of urlObj.searchParams.keys()) {
      if (!allowedSearchParams.includes(k)) {
        urlObj.searchParams.delete(k);
      }
    }

    return urlObj.toString();

  }
}
